import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { finishInvitation, getLoggedUser } from '../actions/api';
import * as types from '../constants/ActionTypes';
import withGTag from '../components/withGTag';
import { GOOGLE_ANALYTICS_ID, WEBSITE_URL } from '../constants/env';
import WebsiteDataShare from '../model/WebsiteDataShare';
export class Authenticator extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            loadTimeout: null,
        };
    }
    UNSAFE_componentWillMount() {
        let token = null;
        const params = window.location.hash.split('&');
        if (params.length > 0 && params[0].startsWith('#access_token=')) {
            token = decodeURIComponent(params[0].replace('#access_token=', ''));
        }
        else if (localStorage.getItem('token')) {
            token = localStorage.getItem('token');
        }
        if (this.props.match &&
            /^\/login/.test(this.props.match.path) &&
            new URL(location.href).searchParams.get('invitationToken')) {
            localStorage.setItem('invitationToken', new URL(location.href).searchParams.get('invitationToken') || '');
        }
        token = token && token !== this.props.user.token ? token : this.props.user.token;
        if (token && !this.props.user.loggedIn) {
            this.authenticate(token, params.includes('firstLogin=true'));
        }
        else if (this.props.checkLogin && !this.props.user.loggedIn) {
            if (!localStorage.getItem('loginRedirectUrl') ||
                /\/login(.*)?/.test(localStorage.getItem('loginRedirectUrl') || '')) {
                if (new URL(location.href).searchParams.get('plan') === 'pro') {
                    localStorage.setItem('loginRedirectUrl', '/settings/billing');
                }
                else {
                    localStorage.setItem('loginRedirectUrl', this.props.match.url);
                }
            }
            this.props.dispatch({ type: types.UNAUTHENTICATED_USER });
        }
    }
    componentWillUnmount() {
        if (this.state.loadTimeout) {
            clearTimeout(this.state.loadTimeout);
        }
    }
    authenticate(token, firstLogin) {
        this.props.dispatch({
            type: types.AUTHENTICATING_USER,
            payload: { token, firstLogin },
        });
        this.loadUserData(true, token);
    }
    loadUserData(initial = false, token) {
        this.props.dispatch(getLoggedUser()).then((action) => {
            if (action.type === types.LOGIN_USER_DETAILS_SUCCESS) {
                this.props.dispatch({
                    type: types.LOGGED_USER,
                    payload: action.response.data,
                });
                const user = this.props.user.user || action.response.data;
                if (user && (user.isLoadingPrOrRepositories || user.fetchedPullRequestsProgress === null)) {
                    this.setState({
                        // @ts-expect-error TS2322: Type 'Timeout' is not assignable to type 'number'.
                        loadTimeout: setTimeout(() => this.loadUserData(), 3000),
                    });
                }
                const oldToken = localStorage.getItem('token');
                if (token) {
                    localStorage.setItem('token', token);
                }
                if (!initial) {
                    return;
                }
                // @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                this.shareTokenWithWebsite(token, oldToken);
                this.props.gtag('config', GOOGLE_ANALYTICS_ID, {
                    user_id: action.response.data.id,
                }); // eslint-disable-line camelcase
                this.finishInvitation();
            }
            else {
                console.error(action);
                if (!localStorage.getItem('loginRedirectUrl') || localStorage.getItem('loginRedirectUrl') === '/') {
                    localStorage.setItem('loginRedirectUrl', this.props.match.url);
                }
                this.props.dispatch({ type: types.UNAUTHENTICATED_USER });
            }
        });
    }
    shareTokenWithWebsite(token, oldToken) {
        if (WEBSITE_URL && oldToken !== token) {
            const websiteDataShare = new WebsiteDataShare();
            websiteDataShare.storeToken(token);
        }
    }
    finishInvitation() {
        if (!localStorage.getItem('invitationToken')) {
            return;
        }
        this.props
            .dispatch(finishInvitation(localStorage.getItem('invitationToken') || ''))
            .then((invitationAction) => {
            if (invitationAction.type === types.FINISH_INVITATION_SUCCESS) {
                this.props.dispatch({
                    type: types.SET_INVITED_ORGANIZATION,
                    payload: invitationAction.response.data,
                });
                this.props.dispatch(getLoggedUser()).then((loginInfoAction) => {
                    if (loginInfoAction.type === types.LOGIN_USER_DETAILS_SUCCESS) {
                        this.props.dispatch({
                            type: types.LOGGED_USER,
                            payload: loginInfoAction.response.data,
                        });
                    }
                });
                localStorage.removeItem('invitationToken');
            }
            else {
                this.props.dispatch({
                    type: types.SET_INVITED_ORGANIZATION,
                    payload: null,
                });
                localStorage.removeItem('invitationToken');
                console.error(invitationAction);
            }
        });
    }
    render() {
        const { match, user, checkLogin } = this.props;
        if (checkLogin && user.unauthenticated && (!match || !/\/login(\/:slug)?/.test(match.path))) {
            return _jsx(Redirect, { to: `/login` + (match && match.params.vcs ? '/' + match.params.vcs : '') });
        }
        return null;
    }
}
Authenticator.defaultProps = {
    checkLogin: false,
};
const mapStateToProps = (state) => ({
    user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export default withGTag(connect(mapStateToProps, mapDispatchToProps)(Authenticator));
